export enum RowSelectionMode {
  PAGE = 'PAGE',
  ALL = 'ALL',
}
